export enum PopoverName {
  PhoneCall = 'phoneCall',
  VideoCall = 'videoCall',
  UnsupportedBrowser = 'unsupportedBrowser',
}
